var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-row',{staticClass:"min-vh-100",attrs:{"no-gutters":""}},[_c('b-col',{attrs:{"xs":"12","sm":"12","md":"3","lg":"2"}},[_c('sider-menu-accordion_deprecated')],1),_c('b-col',{attrs:{"xs":"12","sm":"12","md":"9","lg":"10"}},[_c('router-view')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }